import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { compareStrings } from '@cbridge-utils/object';
import { ICoverageReport } from '../coverageReport.interface';
import { coverageReportStoreSelector } from '../coverageReport.selector';

export const coverageReportListSelector = createCachedSelector(
  [
    path(coverageReportStoreSelector).data(),
    path(coverageReportStoreSelector).listNetworkStatus(),
  ],
  (data, networkStatus) => {
    const list: ICoverageReport[] = Object.values(data)
      .sort((a, b) => compareStrings(a.name, b.name));
    return { list, networkStatus };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
